import type { PdfMergeFn } from '@core/utils/useSiteBoxAppraisalDownload'

export const mergePdfsWithPspdfkit: PdfMergeFn = async (
  firstPdfBytes,
  secondPdfBytes,
) => {
  const PSPDFKit: any = await import('pspdfkit')

  const container = document.createElement('div')
  container.style.position = 'absolute'
  container.style.top = '-9999px'
  container.style.width = '1px'
  container.style.height = '1px'
  document.body.appendChild(container)

  const firstBlob = new Blob([firstPdfBytes], { type: 'application/pdf' })
  const documentUrl = URL.createObjectURL(firstBlob)

  let instance: any
  try {
    instance = await PSPDFKit.load({
      licenseKey: Project.pspdfkitLicenseKey,
      container,
      document: documentUrl,
      baseUrl: `${window.location.protocol}//${window.location.host}/`,
      headless: true,
    })

    const totalPages = instance.totalPageCount

    await instance.applyOperations([
      {
        type: 'importDocument',
        afterPageIndex: totalPages - 1,
        document: new Blob([secondPdfBytes], { type: 'application/pdf' }),
        treatImportedDocumentAsOnePage: false,
      },
    ])

    return await instance.exportPDF()
  } finally {
    if (instance) {
      PSPDFKit.unload(container)
    }
    URL.revokeObjectURL(documentUrl)
    if (container.parentNode) {
      document.body.removeChild(container)
    }
  }
}
